var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component 18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.88889 1.52344C6.92778 1.52344 5.33333 3.11788 5.33333 5.07899V21.079C5.33333 23.0401 6.92778 24.6345 8.88889 24.6345H28.4444C30.4056 24.6345 32 23.0401 32 21.079V5.07899C32 3.11788 30.4056 1.52344 28.4444 1.52344H8.88889ZM15.5556 5.52344H27.1111C27.85 5.52344 28.4444 6.11788 28.4444 6.85677C28.4444 7.59566 27.85 8.1901 27.1111 8.1901H15.5556C14.8167 8.1901 14.2222 7.59566 14.2222 6.85677C14.2222 6.11788 14.8167 5.52344 15.5556 5.52344ZM12.4444 6.85677C12.4444 7.32827 12.2571 7.78045 11.9237 8.11385C11.5903 8.44725 11.1382 8.63455 10.6667 8.63455C10.1952 8.63455 9.74299 8.44725 9.40959 8.11385C9.07619 7.78045 8.88889 7.32827 8.88889 6.85677C8.88889 6.38527 9.07619 5.93309 9.40959 5.59969C9.74299 5.26629 10.1952 5.07899 10.6667 5.07899C11.1382 5.07899 11.5903 5.26629 11.9237 5.59969C12.2571 5.93309 12.4444 6.38527 12.4444 6.85677ZM2.66667 8.1901C2.66667 7.45121 2.07222 6.85677 1.33333 6.85677C0.594444 6.85677 0 7.45121 0 8.1901V22.4123C0 26.5845 3.38333 29.9679 7.55556 29.9679H25.3333C26.0722 29.9679 26.6667 29.3734 26.6667 28.6345C26.6667 27.8957 26.0722 27.3012 25.3333 27.3012H7.55556C4.85556 27.3012 2.66667 25.1123 2.66667 22.4123V8.1901Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModule);
export default __webpack_public_path__ + "static/media/module.0dacded95f48aa6bfc94c73bd6624a20.svg";
export { ForwardRef as ReactComponent };